import img1 from "assets/Projects İmages/getir.jpeg";
import img2 from "assets/Projects İmages/erdem-yuksel.jpeg";
import img3 from "assets/Projects İmages/barber.jpeg";
import img4 from "assets/Projects İmages/spotify.jpeg";
import img5 from "assets/Projects İmages/brandcolors.jpeg";
import img6 from "assets/Projects İmages/pokedex.jpeg";
import img7 from "assets/Projects İmages/ecommerce.png";
import img8 from "assets/Projects İmages/todo-app.png";
import img9 from "assets/Projects İmages/youtube-clone.jpeg";
// import img10 from "assets/Projects İmages/movie-app.jpeg";
import img11 from "assets/Projects İmages/weather-app.jpeg";
import img12 from "assets/Projects İmages/library.jpeg";
import img13 from "assets/Projects İmages/star-wars.jpeg";
import img14 from "assets/Projects İmages/post-project.png";

export const projectsData = [
  {
    id: "starWarsApi",
    image: img13,
    github: "https://github.com/atifsimsek/FMSS-front-end-final-case",
    live: "https://fmss-front-end-final-case.vercel.app/",
  },
  {
    id: "posProject",
    image: img14,
    github: "https://github.com/atifsimsek/pos-application",
    live: "https://pos-application-project-2a9m.onrender.com/",
  },
  {
    id: "ecommerceReactFirebase",
    image: img7,
    github: "https://github.com/atifsimsek/react-redux-firebase-ecommerce",
    live: "https://atifsimsek.github.io/react-redux-firebase-ecommerce/",
  },
  {
    id: "libraryGoogleBooks",
    image: img12,
    github:
      "https://github.com/atifsimsek/patika.dev-react/tree/main/06-react-task-6",
    live: "https://patika-library.vercel.app/",
  },
  {
    id: "youtubeClone",
    image: img9,
    github: "https://github.com/atifsimsek/typescript-react-youtube-clone",
    live: "https://typescript-react-youtube-clone.vercel.app/",
  },
  // {
  //   id: "movieApp",
  //   image: img10,
  //   github: "https://github.com/atifsimsek/next.js-movie-app",
  //   live: "https://next-js-movie-app-lilac.vercel.app/",
  // },
  {
    id: "weatherApp",
    image: img11,
    github:
      "https://github.com/atifsimsek/patika.dev-react/tree/main/03-react-task-3",
    live: "https://weather-app-context-api-patika.vercel.app/",
  },
  {
    id: "getirClone",
    image: img1,
    github: "https://github.com/atifsimsek/getir-react-tailwind-clone",
    live: "https://atifsimsek.github.io/getir-react-tailwind-clone/",
  },
  {
    id: "erdemYuksel",
    image: img2,
    github: "https://github.com/atifsimsek/erdem-yuksel-metal-react",
    live: "https://atifsimsek.github.io/erdem-yuksel-metal-react/",
  },
  {
    id: "barberWebsite",
    image: img3,
    github:
      "https://github.com/atifsimsek/html-css-js-projects/tree/main/Html-Css-Js%20WebSite%20Project/10%20-%20Barber%20Website%20%2BJs",
    live: "https://atifsimsek.github.io/html-css-js-projects/Html-Css-Js%20WebSite%20Project/10%20-%20Barber%20Website%20%2BJs/index.html",
  },
  {
    id: "spotifyClone",
    image: img4,
    github: "https://github.com/atifsimsek/react-tailwind-spotify-clone",
    live: "https://atifsimsek.github.io/react-tailwind-spotify-clone/",
  },
  {
    id: "brandColorsClone",
    image: img5,
    github: "https://github.com/atifsimsek/react-brandcolors-projects",
    live: "https://atifsimsek.github.io/react-brandcolors-projects/",
  },
  {
    id: "todoApp",
    image: img8,
    github: "https://github.com/atifsimsek/react-redux-thunk-todo-app",
    live: "https://react-redux-thunk-todo.netlify.app/",
  },
  {
    id: "pokedex",
    image: img6,
    github:
      "https://github.com/atifsimsek/html-css-js-projects/tree/main/JavaScript%20Project/11%20-%20Pokedex",
    live: "https://atifsimsek.github.io/html-css-js-projects/JavaScript%20Project/11%20-%20Pokedex/index.html",
  },
];
